import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails
} from 'amazon-cognito-identity-js'
import poolData from '../../cognito-pool-data'

const userPool = new CognitoUserPool(poolData)

export const userService = {
    login,
		logout,
		loggedIn,
		getUser,
		getUserSession,
		getUserAttributes,
		userPool
};

export const createUser = (username, password, email, name, family_name, callback) => {
  const attributeList = [
    new CognitoUserAttribute({
      Name: 'name',
      Value: name
    }),
		new CognitoUserAttribute({
			Name: 'email',
			Value: email
		}),
		new CognitoUserAttribute({
			Name: 'family_name',
			Value: family_name
		}),
  ]

  // Username must be unique in a pool, and cant be a valid email format
  // To log in with email, make sure it is set as an alias attribute in Cognito
  // More info: http://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html#user-pool-settings-usernames
  userPool.signUp(username, password, attributeList, null, callback)
}


export const verifyUser = (username, verifyCode, callback) => {
  const userData = {
    Username: username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.confirmRegistration(verifyCode, true, callback)
}

export const authenticateUser = (username, password, callback) => {
  const authData = {
    Username: username,
    Password: password,
  }
  const authDetails = new AuthenticationDetails(authData)
  const userData = {
    Username: username,
    Pool: userPool,
  }
  const cognitoUser = new CognitoUser(userData)
  cognitoUser.authenticateUser(authDetails, {
    onSuccess: result => {
      callback(null, result)
    },
    onFailure: err => {
      callback(err)
    }
  })
}

function login(username, password) {
  	const authData = {
  	  Username: username,
  	  Password: password,
  	}
  	const authDetails = new AuthenticationDetails(authData)
  	const userData = {
  	  Username: username,
  	  Pool: userPool,
  	}
  	const cognitoUser = new CognitoUser(userData)

    return new Promise((resolve, reject) => {
			cognitoUser.authenticateUser(authDetails, {
				onSuccess: result => {
					resolve(result);
    		},
    		onFailure: err => {
    		  reject(err)    		
				}
			})
		})
}

function loggedIn() {
	if (userPool.getCurrentUser()){
		return true;
	}
	else{
		return false;
	}
}

function getUser() {
  const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return Promise.reject("Not Logged in");

	return new Promise((resolve, reject) => {

		cognitoUser.getSession((err, session) => {
  	  if (err) {
  	    console.log(err)
  	    reject(err)
  	  }
  	  //console.log('Session valid?', session.isValid())

  	  cognitoUser.getUserAttributes((err, attributes) => {
  	    if (err) {
					console.log(err);
					reject(err);
				}
				let userAttributes = {}
				for (let i = 0; i < attributes.length; i++){
					userAttributes[attributes[i].Name] = attributes[i].Value
				}
  	    resolve(userAttributes)
  	  })
  	})
	})
}

function getUserSession() {
  const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return Promise.reject("Not Logged in");
	return new Promise((resolve) => {
		cognitoUser.getSession((err, session) => {
			return resolve(session);	
		});
	});
}


function getUserAttributes() {
	return new Promise((resolve, reject) => {
		let user = userPool.getCurrentUser()
		user.getUserAttributes((err, attributes) => {
			if (err) {
				reject(err);
			}
			let userAttributes = {}
			for (let i = 0; i < attributes.length; i++){
				userAttributes[attributes[i].Name] = attributes[i].Value
			}
  	   resolve(userAttributes)
		});
	});
}

function logout() {
	localStorage.clear()
	userPool.getCurrentUser().signOut()
}

export const signOut = () => {
  userPool.getCurrentUser().signOut()
  window.location.reload()
}

export const getCurrentUser = (callback) => {
  const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return false;


  cognitoUser.getSession((err, session) => {
    if (err) {
      console.log(err)
      return
    }

    cognitoUser.getUserAttributes((err, attributes) => {
      if (err) return console.log(err);
      callback(attributes)
    })
  })
}

export const isAuthenticated = (callback) => {
	const cognitoUser = userPool.getCurrentUser()
  if (!cognitoUser) return false;

  cognitoUser.getSession((err, session) => {
    if (err) {
      console.log(err)
      return
    }
		return callback(session.isValid())
	})
}



// WEBPACK FOOTER //
// ./src/_services/user.js